const employeeReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default employeeReducer;